module.exports = __webpack_public_path__ + "static/media/sve.a874a8db.svg";